module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAApCAMAAAD6UwK7AAAAOVBMVEVMaXFJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEaccA6kAAAAEnRSTlMAqwgfF8M35/xafGKPxshrzo4xqUeOAAAAjklEQVR42uWSSw7CMAwF0zap7XzaMvc/LIsiSChhgWABzMpPI1tPSlzFFIOohDi5R4wnZUfzeNR+48bmD9sLUMw7bwVY7i9k0PUyrwq51ZNCuqYE2paMEKoYIDY+gFXRoDReoK7sQRqv0GS+JvOcd3jX49f8PAgyzD1vCoBaxws78qJPnfvdfn/wPp/+32f+2h86FJI4vAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_lock.png
// module id = 2Ztd
// module chunks = 1